var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-popup',{attrs:{"opened":_vm.opened}},[_c('f7-page',[_c('popup-navigation-bar',{attrs:{"title":""},on:{"close":function($event){return _vm.$emit("close")}}}),_c('background',[(_vm.opened)?_c('iframe',{attrs:{"width":"100%","height":"auto","src":_vm.videoUrl,"frameborder":"0","allowfullscreen":"","allow":"autoplay"}}):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }